import { get } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import SustainabilityPageContainer from 'containers/SustainabilityPageContainer';
import Log from 'utils/Log';

const SustainabilityPageController = class {
  static get windowData() {
    const data = get(window, ['ALLBIRDS', 'sustainabilityPage']);

    if (!data) {
      Log.error(
        new Error('Controllers:SustainabilityPageController.windowData -- missing window data!')
      );
    }

    return data;
  }

  static get reportLink() {
    return 'https://cdn.allbirds.com/image/upload/v1728422833/Allbirds_2023_Flight_Status.pdf';
  }

  static mountSustainabilityPageContainer = store => {
    ReactDOM.render(
      <Provider store={store}>
        <SustainabilityPageContainer
          data={SustainabilityPageController.windowData}
          reportLink={SustainabilityPageController.reportLink}
        />
      </Provider>,
      document.getElementById('sustainability-page-container')
    );
  };

  static init = store => {
    SustainabilityPageController.mountSustainabilityPageContainer(store);
  };
};

export default SustainabilityPageController;
